import { FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";

const DeleteDescription: FunctionComponent<{ Id: any, name: string, onDeleteDescription: any }> = (props) => {

    const modalId = `drop${props.name}_${props.Id}`;
    const { t } = useTranslation();

    const HandleDropUser = () => {
        props.onDeleteDescription(props.Id)
    }

    return (<>

        <button type="button" className="btn p-0  hide-arrow marg-left-10" data-bs-toggle="modal"
            data-bs-target={`#${modalId}`} >
            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1014_4605)">
                    <path d="M2.97266 4.6665H13.6393" stroke="#EF4444" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M6.97266 7.3335V11.3335" stroke="#EF4444" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9.63965 7.3335V11.3335" stroke="#EF4444" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M3.63965 4.6665L4.30632 12.6665C4.30632 13.0201 4.44679 13.3593 4.69684 13.6093C4.94689 13.8594 5.28603 13.9998 5.63965 13.9998H10.973C11.3266 13.9998 11.6657 13.8594 11.9158 13.6093C12.1658 13.3593 12.3063 13.0201 12.3063 12.6665L12.973 4.6665" stroke="#EF4444" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M6.30615 4.66667V2.66667C6.30615 2.48986 6.37639 2.32029 6.50141 2.19526C6.62644 2.07024 6.79601 2 6.97282 2H9.63949C9.8163 2 9.98587 2.07024 10.1109 2.19526C10.2359 2.32029 10.3062 2.48986 10.3062 2.66667V4.66667" stroke="#EF4444" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_1014_4605">
                        <rect width="16" height="16" fill="white" transform="translate(0.306152)" />
                    </clipPath>
                </defs>
            </svg>
        </button>


        <div className="modal fade" id={modalId} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="title-18">{t("propertiesPage.confirmation")}</h5>
                    </div>
                    <div className="modal-body text-start">
                        <p className="para-16 mb-3 mt-3">{t(`aiDescTitle.Are you sure you want to delete this ${props.name}`)}</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="button-dash btn-outline-secondary back-trans padd-15 padd-5-15-mb marg-right-16" data-bs-dismiss="modal">
                            {t("propertiesPage.no")}
                        </button>
                        <button type="button" data-bs-dismiss="modal" className="button-dash padd-15 padd-5-15-mb btn-danger" onClick={HandleDropUser}>
                            {t("propertiesPage.yes")}</button>
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}
export default DeleteDescription;
